import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
} from "react-router-dom";
import RootLayout from "./rootLayout";
import Home from "./pages/sign-in/home";
import Dashboard from "./pages/sign-in/dashboard";
import Suppliers from "./pages/suppliers";
import Customers from "./pages/customers";
import SupplierView from "./pages/suppliers/view";
import SupplierAdd from "./pages/suppliers/add";
import SupplierEdit from "./pages/suppliers/edit";
import CustomerView from "./pages/customers/view";
import CustomerAdd from "./pages/customers/add";
import CustomerEdit from "./pages/customers/edit";
import Orders from "./pages/orders";
import OrderView from "./pages/orders/view";
import OrderAdd from "./pages/orders/add";
import OrderEdit from "./pages/orders/edit";
import AdminOrders from "./pages/admin/orders";
import AdminSettings from "./pages/admin/settings";
import AdminFAQ from "./pages/admin/faq";
import CarBrands from "./pages/car-brands";
import CarBrandAdd from "./pages/car-brands/add";
import CarBrandView from "./pages/car-brands/view";
import CarBrandEdit from "./pages/car-brands/edit";
import BrandDiscounts from "./pages/brand-discounts";
import BrandDiscountAdd from "./pages/brand-discounts/add";
import BrandDiscountsView from "./pages/brand-discounts/view";
import BrandDiscountEdit from "./pages/brand-discounts/edit";
import OrderStatusIndex from "./pages/order-status";
import OrderStatusView from "./pages/order-status/view";
import OrderStatusAdd from "./pages/order-status/add";
import OrderStatusEdit from "./pages/order-status/edit";
import ArticleTemplateEdit from "./pages/article-templates/edit";
import ArticleTemplateAdd from "./pages/article-templates/add";
import ArticleTemplateView from "./pages/article-templates/view";
import ArticleTemplates from "./pages/article-templates";
import ArticleGroupDiscounts from "./pages/article-group-discounts";
import ArticleGroupDiscountAdd from "./pages/article-group-discounts/add";
import ArticleGroupDiscountEdit from "./pages/article-group-discounts/edit";
import ArticleGroupDiscountView from "./pages/article-group-discounts/view";
import ArticleDiscounts from "./pages/article-discounts";
import ArticleDiscountAdd from "./pages/article-discounts/add";
import ArticleDiscountEdit from "./pages/article-discounts/edit";
import ArticleDiscountView from "./pages/article-discounts/view";
import AdminSyncStatus from "./pages/admin/sync-status";
import AdminDocumentation from "./pages/admin/documentation";
import AdminDocumentationExport from "./pages/admin/documentation-export";
import ExportedOrders from "./pages/admin/exported-orders";

export function createRoutes() {
  return createBrowserRouter(
    createRoutesFromElements(
      <Route path="/" element={<RootLayout />}>
        <Route path="/" element={<Home />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/suppliers">
          <Route index={true} element={<Suppliers />}></Route>
          <Route index={false} path=":supplierId" element={<SupplierView />}></Route>
          <Route index={false} path="add" element={<SupplierAdd />}></Route>
          <Route index={false} path=":supplierId/edit" element={<SupplierEdit />}></Route>
        </Route>
        <Route path="/customers" >
          <Route index={true} element={<Customers />}></Route>
          <Route index={false} path=":customerId" element={<CustomerView />}></Route>
          <Route index={false} path="add" element={<CustomerAdd />}></Route>
          <Route index={false} path=":customerId/edit" element={<CustomerEdit />}></Route>
        </Route>
        <Route path="/orderstatus" >
          <Route index={true} path=":orderStatusId" element={<Orders />}></Route>
          <Route index={false} path=":orderStatusId/orders/view/:orderId" element={<OrderView />}></Route>
          <Route index={false} path=":orderStatusId/orders/add" element={<OrderAdd />}></Route>
          <Route index={false} path=":orderStatusId/orders/edit/:orderId" element={<OrderEdit />}></Route>
        </Route>
        <Route path="/admin">
          <Route index={false} path="" element={<AdminOrders />}></Route>
          <Route index={false} path="orders" element={<AdminOrders />}></Route>
          <Route index={false} path="exported-orders" element={<ExportedOrders />}></Route>
          <Route index={false} path="faq" element={<AdminFAQ />}></Route>          
          <Route index={false} path="settings" element={<AdminSettings />}></Route>
          <Route index={false} path="order-status" element={<OrderStatusIndex />}></Route>
          <Route index={false} path="order-status/view/:orderStatusId" element={<OrderStatusView />}></Route>
          <Route index={false} path="order-status/add" element={<OrderStatusAdd />}></Route>
          <Route index={false} path="order-status/edit/:orderStatusId" element={<OrderStatusEdit />}></Route>
          <Route index={false} path="article-templates" element={<ArticleTemplates />}></Route>
          <Route index={false} path="article-templates/:articleTemplateId" element={<ArticleTemplateView />}></Route>
          <Route index={false} path="article-templates/add" element={<ArticleTemplateAdd />}></Route>
          <Route index={false} path="article-templates/:articleTemplateId/edit" element={<ArticleTemplateEdit />}></Route>     
          <Route index={false} path="sync-status" element={<AdminSyncStatus />}></Route>     
          <Route index={false} path="documentation" element={<AdminDocumentation />}></Route>
          <Route index={false} path="documentation-export" element={<AdminDocumentationExport />}></Route>
        </Route>
        <Route path="/car-brands">
          <Route index={true} element={<CarBrands />}></Route>
          <Route index={false} path=":carBrandId" element={<CarBrandView />}></Route>
          <Route index={false} path="add" element={<CarBrandAdd />}></Route>
          <Route index={false} path=":carBrandId/edit" element={<CarBrandEdit />}></Route>
        </Route>
        <Route path="/brand-discounts">
          <Route index={true} element={<BrandDiscounts />}></Route>
          <Route index={false} path=":brandDiscountId" element={<BrandDiscountsView />}></Route>
          <Route index={false} path="add" element={<BrandDiscountAdd />}></Route>
          <Route index={false} path=":brandDiscountId/edit" element={<BrandDiscountEdit />}></Route>
        </Route>
        <Route path="/article-group-discounts">
          <Route index={true} element={<ArticleGroupDiscounts />}></Route>
          <Route index={false} path=":articleGroupDiscountId" element={<ArticleGroupDiscountView />}></Route>
          <Route index={false} path="add" element={<ArticleGroupDiscountAdd />}></Route>
          <Route index={false} path=":articleGroupDiscountId/edit" element={<ArticleGroupDiscountEdit />}></Route>          
        </Route>
        <Route path="/article-discounts">
          <Route index={true} element={<ArticleDiscounts />}></Route>
          <Route index={false} path=":articleDiscountId" element={<ArticleDiscountView />}></Route>
          <Route index={false} path="add" element={<ArticleDiscountAdd />}></Route>
          <Route index={false} path=":articleDiscountId/edit" element={<ArticleDiscountEdit />}></Route>       
        </Route>
      </Route>
    )
  );
}
